<ng-container *ngIf="initialized">

    <p-splitbutton class="button-pill mx-2"
                   styleClass="filter-btn"
                   [label]=" householdPersonsCount ? 'Household (' + householdPersonsCount + ')' : 'Household'"
                   icon="fa-sharp fa-solid fa-house mx-2"
                   menuStyleClass="split-button-menu-hover"
                   [model]="uiHouseholdPersons"
                   (contextmenu)="openContextMenu($event, contextMenu)"
                   (onClick)="handleHouseholdClick()"
    >

    </p-splitbutton>

    <p-contextMenu #contextMenu
                   [model]="items"
                   appendTo="body">
    </p-contextMenu>

</ng-container>